/**
 * Tailwind 编译后的 CSS 注入到 Lit Shadow DOM
 *
 * 本模块负责将 Tailwind CSS 编译产物（./tailwind.css）转换为可被 Lit Shadow DOM
 * 使用的 CSSStyleSheet 实例，供 BaseElement 通过 adoptedStyleSheets 注入。
 *
 * 设计决策：
 * - 使用 CSSStyleSheet + replaceSync() 而非 <style> 标签，性能更优且支持共享引用
 * - 采用 ?inline 后缀导入 Vite 产物，获取 CSS 文本字符串而非注入到 <head>
 * - 通过 adoptedStyleSheets 机制，内存中只保留一份样式表对象，所有组件共享引用
 * - 开发模式下支持 HMR（热模块替换），修改 Tailwind 配置后自动更新样式
 *
 * 关联模块：
 * - ./tailwind.css — Tailwind PostCSS 编译输出（由 Vite 插件生成）
 * - ./base-element.ts — 消费 sharedStyleSheet 的基类
 */
import tailwindCSS from './tailwind.css?inline';

// 创建全局唯一的 CSSStyleSheet 实例，所有组件共享引用
const sheet = new CSSStyleSheet();
// 将 Tailwind 编译后的 CSS 文本同步写入样式表（replaceSync 不返回 Promise，适用于初始加载）
sheet.replaceSync(tailwindCSS);

// HMR 支持：开发时热更新自动重新替换
// Vite 开发服务器检测到 tailwind.css 变更时，会通过 import.meta.hot 触发回调，
// 用最新的 CSS 内容替换样式表，实现无需刷新页面的样式热更新
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    if (mod) {
      // mod.default 是更新后的 CSS 文本，同步替换到现有样式表实例
      sheet.replaceSync(mod.default);
    }
  });
}

/** 共享样式表 — 导出给 BaseElement 使用，通过 adoptedStyleSheets 注入到各组件的 Shadow DOM */
export const sharedStyleSheet = sheet;
